import React, { useState } from 'react';
import { Accordion, Card, Button } from 'react-bootstrap';
import { faqData } from 'software_renewal/components/faqData';
import { useSelector } from 'react-redux';
import { dataForLicenseDisplay } from 'software_renewal/redux/selectors';

const FAQs = () => {
  const [activeKey, setActiveKey] = useState(null);
  const licenseInfo = useSelector(dataForLicenseDisplay);
  const { products } = licenseInfo;

  if (!licenseInfo?.products?.length) {
    return null;
  }

  const product = products[0];
  const productSlug = product?.product?.slug;
  const productName = product?.product?.name;

  if (
    !productName ||
    !['ViewMate Deluxe', 'ViewMate Pro'].includes(productName)
  ) {
    return null;
  }

  const handleSelect = (eventKey) => {
    setActiveKey(activeKey === eventKey ? null : eventKey);
  };

  return (
    <div className="faqs-section mt-5">
      <div className="container-fluid container-xl">
        <div className="row">
          <div className="col-12">
            <h2 className="faqs-title font-heavy mb-1">FAQ</h2>
            <p className="faqs-intro font-heavy mb-5">
              Learn more and clarify some doubts about the {productName} case,
              if you need support please{' '}
              <a href="/contact-us" className="contact-link">
                contact us
              </a>
            </p>

            <Accordion activeKey={activeKey} onSelect={handleSelect}>
              {faqData[productSlug].map((faq) => (
                <Card key={faq.id} className="faq-card">
                  <Card.Header className="faq-header">
                    <Accordion.Toggle
                      as={Button}
                      variant="link"
                      eventKey={faq.id.toString()}
                      className="faq-toggle"
                    >
                      <span className="faq-question font-medium">
                        {faq.question}
                      </span>
                      <span
                        className={`faq-arrow ${activeKey === faq.id.toString() ? 'rotated' : ''}`}
                      >
                        <i className="fa fa-chevron-down" />
                      </span>
                    </Accordion.Toggle>
                  </Card.Header>
                  <Accordion.Collapse eventKey={faq.id.toString()}>
                    <Card.Body className="faq-answer">
                      {/* eslint-disable-next-line react/no-danger */}
                      <div dangerouslySetInnerHTML={{ __html: faq.answer }} />
                    </Card.Body>
                  </Accordion.Collapse>
                </Card>
              ))}
            </Accordion>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FAQs;
